import { Component, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-auth-recommendation-modal',
  templateUrl: './auth-recommendation-modal.component.html',
  styleUrls: ['./auth-recommendation-modal.component.scss'],
})
export class AuthRecommendationModalComponent {
  @ViewChild('modalTemplate') modalTemplate: any;

  modalRef!: NgbModalRef;

  prefix = 'auth.signIn';
  qrMicrosoftAndroid =
    'https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en';
  qrMicrosoftApple =
    'https://apps.apple.com/us/app/microsoft-authenticator/id983156458';
  qrGoogleAndroid =
    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en';
  qrGoogleApple =
    'https://apps.apple.com/us/app/google-authenticator/id388497605';

  constructor(public modalService: NgbModal) {}

  openModal() {
    this.modalRef = this.modalService.open(this.modalTemplate, {
      windowClass: 'modal-custom-sm',
    });
  }
}
